import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { logger } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { useUpdateEffect } from '@vista-digital/react-tools';
import { memo, useCallback, useContext, useRef } from 'react';
import { ZoomController } from '../../../subcomponents/zoom-controller/zoom-controller';
import { getMapRectangle, getMapScaleFactor } from '../positioning/map';
import { SeatPickerContextInstance } from '../types/context';
import { SeatPickerMap } from './map';
import { SeatPickerRowLabels } from './row-labels';
const b = bemClassBuilder('v-seat-picker-zoom-controller');
export const SeatPickerZoomController = memo(() => {
    const { data, config, isDisabled } = useContext(SeatPickerContextInstance);
    const { seatLayout } = data;
    const rowLabelsRef = useRef(null);
    const zoomControllerRef = useRef(null);
    const handleTransformationChanged = useCallback((transformation) => setRowLabelsTranslation(transformation, rowLabelsRef), []);
    useUpdateEffect(() => {
        var _a;
        (_a = zoomControllerRef.current) === null || _a === void 0 ? void 0 : _a.resetZoom();
    }, [seatLayout]);
    const scaleFactor = getMapScaleFactor(seatLayout, config);
    const mapRectangle = getMapRectangle(scaleFactor, seatLayout.boundary, config.screen, config.rowLabels);
    const rowLabelsWidth = config.rowLabels.size + config.rowLabels.margin * 2;
    const totalWidth = mapRectangle.width + rowLabelsWidth;
    return (_jsxs(ZoomController, Object.assign({ ref: zoomControllerRef, className: b.block(), contentDimensions: { width: totalWidth, height: mapRectangle.height }, showPanButtons: config.navigation.showPanButtons, showZoomButtons: config.navigation.showZoomButtons, onContentTransformationChanged: handleTransformationChanged }, { children: [_jsx("div", Object.assign({ className: b.element('row-labels', { disabled: isDisabled }), ref: rowLabelsRef, style: { width: `${(rowLabelsWidth / totalWidth) * 100}%` } }, { children: _jsx(SeatPickerRowLabels, { seatLayout: seatLayout, scaleFactor: scaleFactor, mapRectangle: mapRectangle, width: rowLabelsWidth }) })), _jsx("div", Object.assign({ className: b.element('map', { disabled: isDisabled }), style: { width: `${(mapRectangle.width / totalWidth) * 100}%` } }, { children: _jsx(SeatPickerMap, { data: data, rectangle: mapRectangle, scaleFactor: scaleFactor }) }))] })));
});
SeatPickerZoomController.displayName = 'SeatPickerZoomController';
const setRowLabelsTranslation = (transformation, rowLabelsRef) => {
    const rowLabels = rowLabelsRef.current;
    if (!rowLabels) {
        logger.error('Cannot set row label translation on null row labels');
        return;
    }
    const { deltaScale, translation } = transformation;
    // When -x reverse the delta scale here to 'undo' the scaling of the coordinate system within the viewport
    const x = translation.x < 0 ? -translation.x / deltaScale : 0;
    rowLabels.style.transform = `translate3d(${x}px, 0, 0)`;
    const fixedClass = 'v-seat-picker-zoom-controller__row-labels--is-fixed';
    if (x > 0) {
        rowLabels.classList.add(fixedClass);
    }
    else {
        rowLabels.classList.remove(fixedClass);
    }
};
